export var MAX_NUMBER_OF_GUESTS = 8;
export var FORMAT = 'yyyy-MM-dd';
export var DISPLAYABLE_FORMAT = 'EEEE, MMMM dd, yyyy';